import { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';

import type { SectionProps as Props } from './Section.types';

import { useFormWithLinesContext } from '../FormLines.context';
import { LinesSectionContext } from './Section.context';

export const Section = ({ children, mobileLineReducer, required = true, section, sectionIndex, sectionsFieldArray }: Props) => {
  const { control } = useFormWithLinesContext();
  const linesFieldArray = useFieldArray({ control, name: `sections.${sectionIndex}.lines` });

  const context = useMemo(
    () => ({
      section,
      sectionIndex,
      sectionsFieldArray,
      linesFieldArray,
      mobileLineReducer,
      required,
    }),
    [section, sectionIndex, sectionsFieldArray, linesFieldArray, mobileLineReducer, required],
  );

  return <LinesSectionContext value={context}>{children}</LinesSectionContext>;
};
